export default {
  cancelRegistration: 'Cancel Registration',
  select: 'Select',
  month: 'Month',
  day: 'Day',
  year: 'Year',
  back: 'Retour',
  accessCode: "Code d'activation",
  address: 'Adresse',
  callus: 'Appelez-nous',
  city: 'Ville',
  civic: 'Numéro de la maison/civique',
  continue: 'Continuer',
  postalCode: 'Code postal',
  province: 'Province',
  later: 'Je vais le faire plus tard',
  tagNumber: "Numéro d'étiquette",
  petName: "Nom d'animal domestique",
  phoneNumber: 'Numéro de téléphone',
  mobilePhone: 'Mobile',
  homePhone: 'Home',
  workPhone: 'Work',
  login: 'Connexion',
  signUp: 'Inscrivez-vous',
  street: 'Nom de la rue',
  submit: 'Nous faire parvenir',
  email: 'Adresse courriel',
  password: 'Créer un mot de passe',
  firstName: 'Prénom',
  lastName: 'Nom de famille',
  male: 'Mâle',
  female: 'Femelle',
  iAgree: "Je suis d'accord",
  unit: 'Unité/Appartement/Suite',
  welcome: 'Obtenons votre adresse',
  phonePlaceholder: '(___) ___-____',
  yes: 'Oui',
  no: 'Non',
  dog: 'Chien',
  cat: 'Chat',
  optional: 'Optionnel',
  requiredField: ' (Obligatoire)',
  optionalField: ' (Optionnel)',
  success: 'Succès',
  now: 'maintenant',
  selectLocation: 'Select a state',
  ageOptions: {
    underSixMonths: 'Under 6 months',
    sixMonthsToOneYear: '6 months - 1 year',
    oneYear: '1 year',
    timesYears: '{yearNumber} years',
    seventeenPlusYears: '17+ years',
  },
  colors: {
    white: 'Blanc',
    lightGrey: 'Gris clair',
    darkGrey: 'Gris foncé',
    black: 'Noir',
    orange: 'Orange',
    red: 'Rouge',
    cream: 'Crème',
    apricot: 'Abricot',
    golden: 'Or',
    tan: 'Tan',
    brown: 'Brun',
    darkBrown: 'Marron foncé',
    beige: 'Beige',
    blonde: 'Blond',
    fawn: 'Fauve',
    liver: 'Foie',
    chocolate: 'Chocolat',
  },
  validations: {
    messages: {
      _default: 'invalide',
      required: 'obligatoire',
    },
  },
  footer: {
    copyright: 'DocuPet Inc. Tous droits réservés.',
    links: {
      about: 'À propos de DocuPet',
      tos: 'Conditions de service',
      privacy: 'Politique de confidentialité',
    },
  },
  registerBanner: {
    previouslyRegisteredPet: 'Avez-vous déjà autorisé un animal de compagnie?',
    havePreviouslyRegisteredPet:
      'Si vous avez déjà immatriculé votre animal de compagnie, nous avons probablement votre dossier dans nos dossiers.',
    fetchMyRecord: 'Consulter mon dossier',
  },
  registerPanel: {
    join: 'Créez votre compte de licence sécurisé',
    joinInfo: `À partir de ce nouveau compte, vous pouvez gérer votre profil, accéder aux dossiers de licence et utiliser notre service gratuit pour animaux perdus Home<em>Safe</em><sup>&reg;</sup>.`,
    createNewOnlineAccount: 'Create a New Online Account',
    createNewAccountInfo: `Create a free online account and then add any pets you own. You'll gain free access to our Home<em>Safe</em><sup>&reg;</sup> Lost Pet Service with every tag.`,
    benefits: {
      title: 'Benefits of your DocuPet account',
      items: {
        homeSafeService: `Protect your pet and enjoy peace of mind with linked profiles and the Home<em>Safe</em><sup>&reg;</sup> lost pet service`,
        designerTags: `Browse our full collection of designer tag styles, add personalization or design your own!`,
        dashboard: `A central dashboard for all of your pet's important information`,
        changeAccount: `Manage, or make changes to your account at anytime including updating your contact information and making changes to pet details and status`,
      },
    },
    agreeToTCTooltip:
      "In order to complete your online registration, you must agree to DocuPet's Terms of Service and Privacy Policy. If you do not wish to proceed you may visit the Licensing page for alternate ways to complete the licensing process offline. Our Terms of Service and Privacy Policy outline our customers' use of DocuPet services. Please read these terms carefully before accepting.",
    title: 'Enregistrez vos animaux de compagnie,',
    title2: 'et gardez-les en sécurité!',
    alreadyHaveAccount: 'Vous avez déjà un compte?',
    firstNamePlaceholder: 'Entrez votre prénom',
    lastNamePlaceholder: 'Entrer le nom de famille',
    showPassword: 'Masquer le mot de passe',
    hidePassword: 'Montrer le mot de passe',
    emailPlaceholder: 'Entrer adresse courriel',
    passwordPlaceholder: 'Entrer le mot de passe',
    overThePhone: 'Par téléphone',
    backToOnlineRegistration: "Retour à l'inscription en ligne",
    personOrMail: 'En personne ou par courrier',
    otherWaysToRegister: 'Other ways to register:',
  },
  noticeOfCollectionPanel: {
    info: 'I understand that my personal information, as defined by the Municipal Freedom of Information and Protection of Privacy Act (MFIPPA), including (but not limited to) my name, address, and contact information, is collected and will be used in accordance with MFIPPA, the Personal Information Protection and Electronic Documents Act (PIPEDA), and all other relevant privacy legislation.',
    bulletsInfo: 'I understand that the personal information I have provided:',
    bullet1:
      'is collected through a website hosted by DocuPet on behalf of the Corporation of the City of Kingston (the "City");',
    bullet2:
      'will be used by City staff for the registration of my pet in accordance with By-Law 2004-144, being a By-Law to Regulate Animals; and',
    bullet3:
      'may also be used by third parties, partnered with the City, for licensing purposes such as registering pets and enforcing the By-Law to Regulate Animals.',
  },
  overThePhone: {
    title: 'Par téléphone',
    infoHeading: 'Give us a call',
    info2:
      'Veuillez noter que nous ne pouvons accepter que les paiements par carte de crédit (Mastercard, VISA, VISA Débit, American Express ou Discover) par téléphone.',
  },
  personOrMail: {
    title: 'En personne ou par courrier',
  },
  termsOfService: {
    title: 'Conditions de service',
  },
  privacyPolicy: {
    title: 'Colitique de confidentialité',
  },
  welcomePanel: {
    whereLiveWithPet: 'Où habites-tu?',
    civicPlaceholder: '',
    streetPlaceholder: '',
    unitPlaceholder: '',
    cityPlaceholder: '',
    postalCodePlaceholder: '',
    mailingAddressSame:
      "Mon adresse postale est la même que mon adresse personnelle (c'est ici que nous enverrons vos tags)",
    mailingAddress: 'Adresse postale',
    additional: 'Supplémentaire (par ex. P.O. Box ou G.D. Station)',
    additionalPlaceholder: '',
    phoneNumberText: 'Nous allons utiliser cela pour vous contacter si votre animal de compagnie est perdu.',
  },
  provinces: {
    alberta: 'l’Alberta',
    britishColumbia: 'la Colombie-Britannique',
    manitoba: 'le Manitoba',
    ontario: 'l’Ontario',
    quebec: 'le Québec',
    newfoundlandLabrador: 'la Terre-Neuve-et-Labrador',
    newBrunswick: 'le Nouveau-Brunswick',
    novaScotia: 'la Nouvelle-Écosse',
    princeEdwardIsland: 'l’île du Prince-Édouard',
    saskatchewan: 'la Saskatchewan',
    northwestTerritories: 'les Territoires du Nord-Ouest',
    nunavut: 'le Nunavut',
    yukon: 'le Yukon',
  },
  petPanel: {
    aboutYourPet: 'Parlez-nous de votre animal de compagnie',
    petPanelInfo:
      'Information about your pet is required to complete your registration. These basic details will be helpful in identifying your pet should they become lost or found. This information is not shared publicly unless you provide consent within your profile settings.',
    dontHaveAPet: "Vous n'avez pas d'animal de compagnie?",
    dontWantToAddPet: "Je ne veux pas ajouter d'animal",
    doneAddingPet: 'Fait ajouter des animaux de compagnie?',
    skipThisStep: 'Passer cette étape',
    whatKindOfPet: "Quel genre d'animal avez-vous?",
    chooseOne: 'Choisissez-en un',
    petsName: 'Quel est le nom de votre animal de compagnie?',
    petNameEditWarning:
      "Mettez à jour le nom de votre animal si l’orthographe est incorrecte ou si vous modifiez le nom de votre animal. N'utilisez pas ce dossier pour un autre animal de compagnie, car toutes les informations sur votre animal doivent correspondre aux détails figurant sur les documents officiels qui peuvent devoir être fournis pour l'obtention d'un permis.",
    whatBreed: "De quelle race s'agit-il?",
    whatSex: 'De quel sexe sont-ils?',
    knowBirthDate: 'Connaissez-vous leur date de naissance?',
    approximateAge: 'Âge approximatif:',
    whatColor: 'De quelle couleur sont-ils?',
    selectAll: "Sélectionnez tout ce qui s'y rapporte",
    indoorCat: "Chat d'intérieur",
    outdoorCat: "Chat d'extérieur",
    namePlaceholder: 'Entrez un nom',
    breedPlaceholder: 'Entrez la race',
    noMorePets: "Plus d'animaux à ajouter?",
    birthdate: 'Date de naissance',
    dateOptions: {
      jan: 'Jan',
      feb: 'Feb',
      mar: 'Mar',
      apr: 'Apr',
      may: 'May',
      jun: 'Jun',
      jul: 'Jul',
      aug: 'Aug',
      sept: 'Sept',
      oct: 'Oct',
      nov: 'Nov',
      dec: 'Dec',
    },
    petCatOptionsRequired:
      "S'il vous plaît laissez-nous savoir si {catName} est un chat intérieur ou un chat extérieur.",
    petSpeciesRequired: "Please select your pet's species",
    petNameRequired: "Please enter your pet's name",
    petBreedRequired: "Please enter your pet's breed",
    petSexRequired: "Please select your pet's sex",
    petAgeRequired: "Please provide your pet's age",
    petApproximateBirthdateRequired: "Please approximate your pet's age",
    petColorRequired: 'Please pick at least one color',
    petWithNameExists: 'A pet with that name already exists',
  },
  medPanel: {
    is: 'Est ',
    does: 'Fait ',
    isFixed: ' est stérilisé(e)?',
    isMicrochipped: ' micropucé(e)?',
    whatVet: ' a-t-il un vétérinaire?',
    rabiesExpiryBefore: '',
    rabiesExpiryAfter: "'s rabies vaccination expiry date",
    verifyLabel1: 'I verify that ',
    verifyLabel2: "'s information contained within this form is correct, and ",
    verifyLabel3: "'s vaccines are up to date.",
    microchipNumber: 'Microchip Number',
  },
  addProceedPanel: {
    title: 'Merci!',
    title2: "C'est tout ce dont nous avons besoin",
    addAnotherPet: 'Ajouter un autre animal',
  },
  addImage: {
    title: 'Ajouter une photo pour',
    info: 'Uploading a photo of your pet to their profile will help in quickly identifying them should they become lost',
    addPhoto: 'Ajouter une photo',
    changePhoto: 'Changer la Photo',
    bullets: {
      recentPhoto: 'Ensure photos are recent and legible',
      multiplePhotos:
        'Upload multiple photos from inside your account to showcase any markings or characteristics unique to your pet',
      directlyFromDevice: 'Snap a photo directly from your device camera, or upload from gallery',
      notSharedPublicly: 'Photos are not shared publicly unless you provide consent within your profile settings',
    },
  },
  ownerPanel: {
    title: 'Au propos de vous',
    contactInfoRequired: `Contact information is required to complete your registration. Your physical address and phone number are needed to ship your order and also serves as crucial information for our Home<em>Safe</em><sup>&reg;</sup> team to rely on in the event of your pet becoming lost or found.`,
    whereDoYouLive: 'Where do you live?',
    howToPopulateAddress:
      "To begin populating your address, type your house number followed by your street name (all street types are abbreviated, for example “street” becomes “st.”). If your address isn't automatically populating, check that all spelling and information is correct and only if you must, enter it manually in the fields below.",
    info: "Si quelqu'un trouve votre animal de compagnie, c'est ainsi que nous saurons où se trouve leur maison! C'est aussi où nous allons expédier vos tags.",
    tellUsAboutYou: 'Nous aurons besoin de votre numéro de téléphone',
    whatIsYourPhoneNumber: 'Quel est votre numéro de téléphone?',
    primaryPhone: 'Téléphone primaire',
    secondaryPhone: 'Téléphone secondaire',
    birthdate: '... et votre date de naissance',
  },
  paperwork: {
    documentsFor: 'Documents pour',
    pleaseAddRabies: 'Veuillez ajouter un certificat de vaccination antirabique',
    pleaseAddSpayNeuter: 'Veuillez ajouter un certificat Spay / Neuter',
    whatHappensAfter: 'Que se passe-t-il après avoir terminé le processus de licence?',
    existingCopy: 'Documentation uploaded via the online system is reviewed within two business days.',
  },
  licenseSummary: {
    title: 'Nous sommes le partenaire officiel des licences pour animaux de compagnie de ',
    oops: 'Oops!',
    problemLoadingLicenses1:
      "Nous n'avons pas pu trouver de licences pour postuler à un ou plusieurs de vos animaux de compagnie. Veuillez contacter le service clientèle en appelant ",
    problemLoadingLicenses2: ' entre 9am - 8pm EST, ou en nous envoyons par e-mail à info@docupet.com',
  },
  input: {
    addressValidationError: "L'adresse n'est pas valide, veuillez vérifier les champs ci-dessus et réessayer.",
    mailingAddress: {
      label: 'Quelle est votre adresse postale?',
    },
    streetAddress: {
      label: 'Adresse de rue',
    },
    postalCode: {
      label: 'Code Postal',
      placeholder: 'Entrez le code postal',
    },
    province: {
      label: 'Province',
    },
    city: {
      label: 'Ville',
      placeholder: 'Entrez le nom de la ville',
    },
    unit: {
      label: 'Unité / APT / SUITE',
      placeholder: '',
    },
    street: {
      label: 'Rue',
      placeholder: 'Entrez le nom de la rue',
    },
    civic: {
      label: 'Nombre',
      placeholder: '',
    },
    phoneNumber: {
      placeholder: 'Entrez le numéro de téléphone',
      remove: 'Supprimer',
      addAnotherNumber: 'Ajouter un autre numéro',
      primaryPhone: {
        label: 'Quel est votre numéro de téléphone principal?',
      },
      secondaryPhone: {
        add: 'Ajoutez vos numéros de téléphone secondaires',
      },
      customErrorMessage: {
        hasValue: 'Please enter your ten digit phone number',
        isEmpty: 'Please enter your phone number',
      },
    },
  },
  meta: {
    title: {
      BaseURL: 'Rejoindre DocuPet',
      ContactDetails: 'Au propos de vous',
      AboutYourPet: 'Parlez-nous de votre animal de compagnie',
      AddAnotherPet: 'Merci!',
      AddPetImage: 'Ajouter une photo',
      FindLicensingCommunity: 'Find Your License Community',
    },
  },
  errorMessages: {
    error: 'ERROR',
    duplicatePetCancelRegistration:
      "Si vous souhaitez utiliser l'adresse e-mail fournie pour votre dossier existant, veuillez annuler cette inscription maintenant. Notez que si vous procédez à l'annulation de cet enregistrement d'enregistrement que vous avez commencé, celui-ci sera définitivement supprimé.",
    poBoxOnly:
      'We require a physical address for your profile in the event that your pet becomes lost and needs to be returned to you. You may add an additional mailing address by unchecking the box below.',
    genericError: 'An error occurred while registering, please try again!',
    defaultRequired: 'The {field} is required',
    termsOfServiceRequired: "Veuillez lire et accepter les conditions d'utilisation pour continuer",
    passwordConfirmationDoesntMatch: 'Password confirmation does not match',
    invalidCharacters: 'The {field} has invalid characters',
  },
  provincesAbbr: {
    CA_AB: `Alberta`,
    CA_BC: `British Columbia`,
    CA_MB: `Manitoba`,
    CA_NB: `New Brunswick`,
    CA_NL: `Newfoundland and Labrador`,
    CA_NT: `Northwest Territories`,
    CA_NS: `Nova Scotia`,
    CA_NU: `Nunavut`,
    CA_ON: `Ontario`,
    CA_PE: `Prince Edward Island`,
    CA_QC: `Quebec`,
    CA_SK: `Saskatchewan`,
    CA_YT: `Yukon`,
    US_AL: `Alabama`,
    US_AK: `Alaska`,
    US_AZ: 'Arizona',
    US_AR: `Arkansas`,
    US_CA: `California`,
    US_CO: `Colorado`,
    US_CT: `Connecticut`,
    US_DE: `Delaware`,
    US_FL: `Florida`,
    US_GA: `Georgia`,
    US_HI: `Hawaii`,
    US_ID: `Idaho`,
    US_IL: `Illinois`,
    US_IN: `Indiana`,
    US_IA: `Iowa`,
    US_KS: `Kansas`,
    US_KY: `Kentucky`,
    US_LA: `Louisiana`,
    US_ME: `Maine`,
    US_MD: `Maryland`,
    US_MA: `Massachusetts`,
    US_MI: `Michigan`,
    US_MN: `Minnesota`,
    US_MS: `Mississippi`,
    US_MO: `Missouri`,
    US_MT: `Montana`,
    US_NE: `Nebraska`,
    US_NV: `Nevada`,
    US_NH: `New Hampshire`,
    US_NJ: `New Jersey`,
    US_NM: `New Mexico`,
    US_NY: `New York`,
    US_NC: `North Carolina`,
    US_ND: `North Dakota`,
    US_OH: `Ohio`,
    US_OK: `Oklahoma`,
    US_OR: `Oregon`,
    US_PA: `Pennsylvania`,
    US_RI: `Rhode Island`,
    US_SC: `South Carolina`,
    US_SD: `South Dakota`,
    US_TN: `Tennessee`,
    US_TX: `Texas`,
    US_UT: `Utah`,
    US_VT: `Vermont`,
    US_VA: `Virginia`,
    US_WA: `Washington`,
    US_WV: `West Virginia`,
    US_WI: `Wisconsin`,
    US_WY: `Wyoming`,
  },
  licensingCommunity: {
    title: '@:meta.title.FindLicensingCommunity',
    leading:
      'We provide pet licensing services to over 230 jurisdictions across {provinceCount} states. We add a new community partner every few days!',
    subtitle: 'Select your state below to see a list of DocuPet licensing communities.',
    selectLocation: 'Select a state',
    notSeeing: 'Not seeing your community, that’s OK!',
    shop: "We are nationwide, <a href={url} class='text-decoration-underline'>register for free now</a> and you’ll be informed if you can purchase your pet license from within your DocuPet profile in the future.",
    communityCount:
      'DocuPet provides licensing services in the community below. Click the name of your community to go to your local licensing site.| DocuPet provides licensing services in the {count} communities below. Click the name of your community to go to your local licensing site.',
  },
};
